import { HiOutlineExclamationCircle } from "react-icons/hi";
import { Typography } from "@material-tailwind/react";

export default function HelperInput({ helperText, hideIcon = false, ...props }) {
    return (
        <div className="flex gap-1.5 text-foreground">
            {!hideIcon && <HiOutlineExclamationCircle className="h-3.5 w-3.5 shrink-0 translate-y-[3px] stroke-2" />}
            <Typography type="small">
                {helperText}
            </Typography>
        </div>
    )
}